import { fetchClient, API_BASE_URL } from '../../../config/api';

/**
 * Service to fetch the captcha SVG image and set up the session
 */
export const getCaptcha = async () => {
  // Use raw fetch for captcha because it needs to return raw text/svg and include credentials
  // And it might not return JSON.
  const response = await fetch(`${API_BASE_URL}/captcha?t=${Date.now()}`, {
    credentials: 'include'
  });
  
  if (!response.ok) {
    throw new Error('HTTP ' + response.status + ': Error al obtener el captcha');
  }
  
  const text = await response.text();
  return text;
};

/**
 * Service to authenticate the admin
 */
export const loginAdmin = async (password, captchaText) => {
  const response = await fetchClient('/login', {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({ password, captchaText }),
  });
  
  return await response.json();
};

/**
 * Service to check if the current session is valid
 */
export const checkAuthStatus = async () => {
  const response = await fetchClient('/verify', {
    method: 'GET',
    credentials: 'include',
  });
  
  return await response.json();
};

/**
 * Service to logout the admin
 */
export const logoutAdmin = async () => {
  const response = await fetchClient('/logout', {
    method: 'POST',
    credentials: 'include',
  });
  
  return await response.json();
};
